import React, { useReducer, useContext, ReactNode, Dispatch } from 'react';

import ContextDevTool from 'react-context-devtool';

import {
  Actions,
  StateContext as StateContextInterface,
} from 'core/context/main';
import reducer from 'core/context/main/reducer';

interface Dictionary {
  [x: string]: any;
}

interface ILanguage {
  es: Dictionary;
  en: Dictionary;
}

function initializeState(languages: ILanguage, defaultLanguage: string) {
  const availableLanguages = Object.keys(languages);
  if (availableLanguages.indexOf(defaultLanguage) < 0)
    defaultLanguage = availableLanguages[0];
  return {
    dictionary: languages,
    currentLang: defaultLanguage,
    availableLanguages: availableLanguages,
  };
}

const StateContext = React.createContext({} as StateContextInterface);
const DispatchContext = React.createContext({} as Dispatch<Actions>);

export const useContextI18nState = () => useContext(StateContext);
export const useContextI18nDispatch = () => useContext(DispatchContext);

/**
 * Component that provides component
 * I18nContext
 * @category Component
 * @id i18n
 */
export function I18nContext({
  children,
  languages,
  initialize,
}: {
  children: ReactNode;
  languages: ILanguage;
  initialize: string;
}) {
  const [state, dispatch] = useReducer(
    reducer,
    initializeState(languages, initialize)
  );
  return (
    <DispatchContext.Provider value={dispatch}>
      <StateContext.Provider value={state}>
        <ContextDevTool
          context={StateContext}
          id="axpo-lang"
          displayName="Axpo Language"
        />
        {children}
      </StateContext.Provider>
    </DispatchContext.Provider>
  );
}
